import cx from 'classnames';
import React from 'react';

import { SBER_QR_PALETTE } from '../../constants/sber-qr-palette.constant';

type SberQrButtonProps = {
  label?: string;
  onClick?: () => void;
  primary?: boolean;
  link?: boolean;
  disabled?: boolean;
  className?: string;
  children?: React.ReactNode;
};

export const SberQrButton: React.FC<SberQrButtonProps> = ({
  label,
  onClick,
  primary,
  link,
  disabled,
  className,
  children,
}) => {
  if (link) {
    return (
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        style={{ color: SBER_QR_PALETTE.muted }}
        className={cx(
          'tw-bg-transparent tw-border-0 tw-underline tw-cursor-pointer tw-py-0 disabled:tw-cursor-not-allowed',
          className,
        )}
      >
        {children}
        {label}
      </button>
    );
  }

  if (primary) {
    return (
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        style={{
          background: disabled
            ? SBER_QR_PALETTE.brightBg
            : `linear-gradient(135deg, ${SBER_QR_PALETTE.bright}, #19bc78)`,
          color: disabled ? SBER_QR_PALETTE.muted : '#04170e',
        }}
        className={cx(
          'tw-flex tw-gap-[10px] tw-justify-center tw-items-center tw-border-none tw-font-[820] tw-cursor-pointer disabled:tw-cursor-not-allowed',
          { 'tw-shadow-[0_11px_28px_rgba(37,209,139,.23)]': !disabled },
          className,
        )}
      >
        {children}
        {label}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      style={{
        borderColor: SBER_QR_PALETTE.line,
        color: SBER_QR_PALETTE.muted,
      }}
      className={cx(
        'tw-flex tw-items-center tw-justify-center tw-gap-2 tw-border tw-border-solid tw-bg-transparent tw-cursor-pointer disabled:tw-cursor-not-allowed',
        className,
      )}
    >
      {children}
      {label}
    </button>
  );
};
